// extracted by mini-css-extract-plugin
export default {"page":"styles_page__Q4gGG","header":"styles_header__VfI4D","body":"styles_body__njGCG"};